import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import API from "../api";
import "./EmailNextScreen.css";
import profile from "../assets/images/profile.png";
import imageMapper from '../imageMapper';

const BusinessFreeNextScreen = () => {
    const navigate = useNavigate();
    const location = useLocation();

    const module_id = location.state?.module_id || 16;
    const section_id = location.state?.section_id || 1;
    const screen_id = location.state?.screen_id || 1;
    const screenCounter = parseInt(location.state?.screenCounter) || 1;
    const sectionCounter = location.state?.sectionCounter || 1;
    const scorePerQuestion = location.state?.scorePerQuestion;
    const numberOfTrys = location.state?.numberOfTrys;
    const moduleScore = location.state?.moduleScore;

    const [paragraphs, setParagraphs] = useState([]);
    const [title, setTitle] = useState("");
    const [visibleParagraphs, setVisibleParagraphs] = useState(1);
    const [maxScreen, setMaxScreens] = useState(0);
    const [loading, setLoading] = useState(true);
    const [userData, setUserData] = useState({ first_name: "", last_name: "", username: "", score: 0, rank: 4, completion: "10%", days: 0 });
    const [image, setImage] = useState();
    const rawUserId = localStorage.getItem("userId");
    const userId = rawUserId && rawUserId !== "null" ? parseInt(rawUserId, 10) : null;
    const [isButtonDisabled, setIsButtonDisabled] = useState(false);


    // ✅ DODAJTE: State za final screen
    const [finalScreenData, setFinalScreenData] = useState(null);

    const isFinalStep = visibleParagraphs === paragraphs.length;

    // Funkcija za dohvaćanje rezultata
    const fetchUserScore = async () => {
        if (!userId) {
            console.error("Greška: userId je null ili nije postavljen.");
            return 0;
        }
        try {
            const scoreResponse = await API.get(`/module/score/${userId}`);
            const userScore = scoreResponse.data[0]?.score || 0;
            return userScore;
        } catch (error) {
            console.error("Greška pri dohvaćanju score-a:", error);
            return 0;
        }
    };

    useEffect(() => {
        if (paragraphs.length > 0) {
            const currentParagraph = paragraphs[visibleParagraphs - 1];
            if (currentParagraph?.image) {
                setImage(imageMapper[currentParagraph.image]);
            }
        }
    }, [visibleParagraphs, paragraphs]);

    useEffect(() => {
        console.log("🆕 Novi screen_id:", screen_id);
        console.log("📌 Novi section_id:", section_id);
        console.log("📌 Novi module_id:", module_id);
        console.log("🔑 Trigger zbog location.key:", location.key);
    }, [screen_id, section_id, module_id, location.key]);

    useEffect(() => {
        console.log("📌 EmailNextScreen primio state:", location.state);
        const initializeData = async () => {
            setLoading(true);

            setVisibleParagraphs(1);

            try {
                // Dohvati paragraf
                const paragraphsResponse = await API.get(`module/getParagraphs/${module_id}/${section_id}/${screen_id}`);
                console.log("📌 API Odgovor:", paragraphsResponse.data);
                console.log("📥 Novi paragrafi stigli iz API-ja:", paragraphsResponse.data);

                if (paragraphsResponse.data.length > 0) {
                    console.log("✅ Paragrafi pronađeni:", paragraphsResponse.data);
                    setParagraphs(paragraphsResponse.data);
                    console.log("📦 paragraphs postavljen na:", paragraphsResponse.data);
                    setTitle(paragraphsResponse.data[0]?.title || "");
                    const imagePath = paragraphsResponse.data[0].image;
                    setImage(imageMapper[imagePath]);
                } else {
                    console.warn("❌ API nije vratio paragraf za screen_id:", screen_id);
                }

                // Dohvati maksimalni broj ekrana
                const maxScreensResponse = await API.get(`module/getMaxNumOfScreens/${module_id}/${section_id}`);
                setMaxScreens(parseInt(maxScreensResponse.data) || 1);

                // ✅ DODAJTE: Dohvati final screen podatke
                const finalScreenResponse = await API.get(`module/getFinalScreen/${module_id}`);
                console.log("📌 Final screen data:", finalScreenResponse.data);
                setFinalScreenData(finalScreenResponse.data[0]);

                // Dohvati podatke korisnika
                const userResponse = await API.get(`/user/userD`);
                const userDataFromApi = userResponse.data?.data?.[0];

                if (userDataFromApi) {
                    setUserData(prevData => ({
                        ...prevData,
                        first_name: userDataFromApi.first_name || "N/A",
                        last_name: userDataFromApi.last_name || "N/A",
                        username: userDataFromApi.username || "N/A",
                        rank: userDataFromApi.rank || 4,
                        completion: userDataFromApi.completion || "10%",
                        days: Math.max(0, Math.floor((new Date("2025-12-12") - new Date()) / (1000 * 3600 * 24)))
                    }));
                }

                // Uvijek povuci score iz baze
                const currentScore = await fetchUserScore();
                console.log("🎯 Score iz baze:", currentScore);

                setUserData(prevData => ({
                    ...prevData,
                    score: currentScore
                }));
                localStorage.setItem("userScore", currentScore.toString());

            } catch (error) {
                console.error("❌ Greška pri dohvaćanju podataka iz API-ja:", error);
            } finally {
                setLoading(false);
            }
        };

        initializeData();
    }, [module_id, section_id, screen_id, location.key]);

    useEffect(() => {
        console.log("🔄 useEffect triggered: visibleParagraphs or paragraphs changed");
        console.log("📄 paragraphs:", paragraphs);
        console.log("👀 visibleParagraphs:", visibleParagraphs);

        if (paragraphs.length > 0) {
            const currentParagraph = paragraphs[visibleParagraphs - 1];
            console.log("➡ currentParagraph:", currentParagraph);

            if (currentParagraph?.image) {
                console.log("🖼 Image path:", currentParagraph.image);
                console.log("🎨 Mapped image:", imageMapper[currentParagraph.image]);
                setImage(imageMapper[currentParagraph.image]);
            } else {
                console.log("⚠ currentParagraph HAS NO image key");
            }
        }
    }, [visibleParagraphs, paragraphs]);

    useEffect(() => {
        // zaključaj button kad dođe novi screen
        setIsButtonDisabled(true);

        const t = setTimeout(() => {
            setIsButtonDisabled(false);
        }, 0);

        return () => clearTimeout(t);

    }, [screen_id]);
    const handleNext = async () => {
        console.log("👉 handleNext CLICKED");
        console.log("📌 visibleParagraphs prije klika:", visibleParagraphs);
        console.log("📄 paragraphs.length:", paragraphs.length);
        if (isButtonDisabled) return; // spriječi spam klik

        // 🔥 1) ODMAH prikaži sljedeći paragraf
        if (visibleParagraphs < paragraphs.length) {
            setVisibleParagraphs(prev => {
                console.log("➡ Prikazujemo sljedeći paragraf:", prev + 1);
                return prev + 1;
            });
        }
        else {
            // ako su svi paragrafi prikazani → ide dalje
            const currentScore = await fetchUserScore();
            navigate("/business-free", {
                state: {
                    module_id,
                    section_id,
                    screen_id: screen_id + 1,
                    screenCounter: screenCounter ? screenCounter + 1 : 1,
                    sectionCounter,
                    scorePerQuestion: scorePerQuestion || 0,
                    numberOfTrys,
                    moduleScore
                }
            });
            return;
        }

        // 🔒 2) SAD tek uključi 2-second rule
        setIsButtonDisabled(true);
        setTimeout(() => {
            setIsButtonDisabled(false);
        }, 0);
    };

    const handleRestart = async () => {
        const currentScore = await fetchUserScore();
        const newScreenId = Math.max(1, screen_id - (screenCounter - 1));

        navigate("/business-free", {
            state: {
                module_id,
                section_id,
                screen_id: newScreenId,
                screenCounter: 1,
                sectionCounter: sectionCounter,
                scorePerQuestion: scorePerQuestion,
                moduleScore,
                numberOfTrys,
            }
        });
    };

    const handleQuestions = async () => {
        const currentScore = await fetchUserScore();

        console.log("✅ Idemo na pitanja sa screenCounter:", screenCounter);
        navigate("/business-final", {
            state: {
                module_id,
                section_id,
                screen_id,
                screenCounter,
                sectionCounter: sectionCounter,
                scorePerQuestion: scorePerQuestion,
                maxScreen,
                numberOfTrys,
                moduleScore
            }
        });
    };

    const handleFinishModule = async () => {
        const currentScore = await fetchUserScore();

        console.log("🎉 Završavamo modul!");

        if (finalScreenData && finalScreenData.final_screen) {
            let finalRoute = "";
            switch (finalScreenData.final_screen) {
                case "EmailFinals":
                    finalRoute = "/email-final";
                    break;
                case "PasswordSecurityFinalScreen":
                    finalRoute = "/password-security-final-screen";
                    break;
                case "MalwareFinalScreen":
                    finalRoute = "/malware-final-screen";
                    break;
                default:
                    finalRoute = "/dashboard";
            }

            navigate(finalRoute, {
                state: {
                    module_id,
                    moduleScore
                }
            });
        } else {
            navigate("/dashboard");
        }
    };

    const handleLogout = () => {
        localStorage.removeItem("token");
        localStorage.removeItem("userScore");
        navigate("/login");
    };

    return (
        <div className="dashboard-container">
            <div className="main-content4">
                <div className="content-wrapper">
                    <div className="email-prevare-content4">
                        {loading ? (
                            <p className="loading-text"></p>
                        ) : paragraphs.length > 0 ? (
                            <div>
                                <h2 className="module-title4">{title}</h2>
                                {paragraphs.slice(0, visibleParagraphs).map((paragraph, index) => (
                                    //promjena za tekst novi red
                                    <p
                                        key={index}
                                        className="module-description4"
                                        dangerouslySetInnerHTML={{
                                            __html: paragraph.paragraph_text.replace(/\n/g, "<br />")
                                        }}
                                    />
                                ))}

                                <div className="button-group">
                                    {screenCounter < maxScreen || visibleParagraphs < paragraphs.length ? (
                                        <button
                                            disabled={isButtonDisabled}
                                            onClick={handleNext}
                                            className={`next-button4 ${isFinalStep ? "final-button" : "initial-button"} ${isButtonDisabled ? "disabled-button" : ""}`}
                                        >
                                            {isFinalStep ? "NEXT" : "Tap to continue"}
                                        </button>
                                    ) : (
                                        <>
                                            {/* ✅ PROMJENA: Koristite handleFinishModule kada je završetak */}
                                            {finalScreenData && finalScreenData.count === 0 ? (
                                                <button className="question-button4" onClick={handleFinishModule}>
                                                    Završi modul
                                                </button>
                                            ) : (
                                                <>
                                                    <button className="restart-button4" onClick={handleRestart}>Repeat</button>
                                                    <button className="question-button4" onClick={handleQuestions}>Finish</button>
                                                </>
                                            )}
                                        </>
                                    )}
                                </div>
                            </div>
                        ) : (
                            <p className="error-text">Nema podataka za prikaz.</p>
                        )}
                    </div>
                    <div className="media-container4">
                        {<img src={image} alt="Illustration" className="media4" />}
                    </div>
                </div>
            </div>

            <div className="sidebar">
                <div className="profile">
                    <img src={profile} alt="Profile" className="profile-img" />
                    <h4>{userData.first_name} {userData.last_name}</h4>
                    <p>@{userData.username}</p>
                </div>
                <div className="profile-info">
                    <div className="profile-info-header">
                        <h4>Profile Info</h4>
                    </div>
                    <div className="info-item"><span>🏆 Rank:</span> {userData.rank}</div>
                    <div className="info-item"><span>💡 Total score:</span> {userData.score}</div>
                    <div className="info-item"><span>❌ Completion:</span> {userData.completion}</div>
                    <div className="info-item"><span>📅 Days:</span> {userData.days}</div>
                </div>
                <div className="logout-container">
                    <button className="logout-btn" onClick={handleLogout}>Log out</button>
                </div>
            </div>
        </div>
    );
};

export default BusinessFreeNextScreen;